export default {"src":"/_next/static/media/seasonal-use.e77f8fb6.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};